import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-model/brand-kit";
import { fontWeightValues } from "@redotech/redo-model/signup-form";
import {
  RedoTextInput,
  RedoTextInputProps,
} from "./arbiter-components/input/redo-text-input";
import * as css from "./brand-kit-text-input.module.css";

/* Memoizing this causes the signup form builder to not update the override styles */
export const BrandKitTextInput = function BrandKitTextInput({
  brandKit,
  override,
  ...props
}: Omit<RedoTextInputProps, "style"> & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
}) {
  const style = getInputStyles(brandKit, override);
  return (
    <RedoTextInput
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};

function getInputStyles(
  brandKit: BrandKit,
  override?: Override<InputStyleDefinition>,
): React.CSSProperties {
  const styles = override ?? brandKit?.inputs;

  return {
    backgroundColor: styles.backgroundColor,
    color: styles.textColor,
    borderWidth: `${styles.border.stroke.weightPx}px`,
    borderStyle: "solid",
    borderColor: styles.border.stroke.color,
    width: "100%",
    borderRadius: `${styles.border.cornerRadiusPx}px`,
    fontFamily:
      "fontReference" in styles
        ? brandKit?.font.fontFamily
        : styles.font.fontFamily,
    fontSize: `${"fontReference" in styles ? brandKit?.font.hierarchy[styles.fontReference].fontSizePx : styles.font.fontSizePx}px`,
    fontWeight:
      fontWeightValues[
        "fontReference" in styles
          ? brandKit?.font.hierarchy[styles.fontReference].fontWeight
          : styles.font.fontWeight
      ],
    padding: `${styles.paddingPx}px`,
  };
}
